import styled from '@emotion/styled';
import React, { useState } from 'react';
import { UnlimitedIcon } from '../../svg';
import { RichTextRenderer } from '../RichTextRenderer';
import Modal from '../Modal/Modal';

const StyledUnlimitedWrapper = styled.div`
	.dmlp__conti-upgrade {
		& > div:first-of-type {
			padding: 0 !important;
		}
	}

	.dmlp__unlimited-upgrade__cta .btn.law {
		height: auto !important;
	}
`;

const UnlimitedUpgrade = ({
	brandData = '',
	handleUnlimited,
	ULItemcode = '',
	ULItemcodeNorthNZ = '',
	ULItemcodeSouthNZ = '',
	title,
	copy,
	tc,
	logo,
	unlForProspects,
	ctaCopy,
	noThanksCTACopy,
	promoCode,
}) => {
	const [showModal, setShowModal] = useState(false);

	let ULitemCodeAU = brandData.ULitemCode;
	if (ULItemcode) {
		ULitemCodeAU = ULItemcode;
	}

	let ULitemCodeNZNorth = brandData.ULitemCodeNorth;
	let ULitemCodeNZSouth = brandData.ULitemCodeSouth;

	if (ULItemcodeNorthNZ) {
		ULitemCodeNZNorth = ULItemcodeNorthNZ;
	}

	if (ULItemcodeSouthNZ) {
		ULitemCodeNZSouth = ULItemcodeSouthNZ;
	}

	return (
		<StyledUnlimitedWrapper>
			<div className='dmlp__member-checkout dmlp__conti-upgrade dmlp__unlimited-upgrade position-relative'>
				<div>
					<div className='dmlp__unlimited-upgrade__icon text-center mb-20'>
						{logo ? (
							<img
								src={logo}
								alt='Unlimited'
								className='img-responsive d-inline-block'
							/>
						) : brandData.tag === 'vir' ? (
							<img
								src='/images/au/en/brands/virgin/misc/delivery-vir.jpg'
								alt='Unlimited'
								className='img-responsive d-inline-block'
							/>
						) : brandData.tag === 'adc' ? (
							<img
								src='/images/au/en/brands/adc/misc/delivery-adc.jpg'
								alt='Unlimited'
								className='img-responsive d-inline-block'
							/>
						) : brandData.tag === 'newstf' ? (
							<img
								src='/images/au/en/brands/newstf/misc/delivery-newstf.jpg'
								alt='Unlimited'
								className='img-responsive d-inline-block'
								onError={(e) => {
									e.target.onerror = null;
									e.target.src =
										'/images/au/en/brands/newstf/misc/delivery-newstf.jpg';
								}}
							/>
						) : (
							<UnlimitedIcon />
						)}
					</div>

					<h3 className='font-weight-bold mt-0 mb-20 text-center lower'>
						{title ? title : 'Get 12 months of free delivery for only $10*'}
					</h3>

					<div className='dmlp__unlimited-upgrade__subtitle pb-40 text-center'>
						{copy ? (
							copy
						) : (
							<>
								Available only on selected offers. Don’t miss out.
								<span className='d-block font-weight-bold'>
									Join UNLIMITED today and SAVE!
								</span>
							</>
						)}
					</div>

					<div className='dmlp__conti-upgrade__cta dmlp__unlimited-upgrade__cta'>
						{brandData.country === 'AU' ? (
							<button
								type='button'
								className={`unlimited-upgrade__yes btn btn-${
									brandData.tag === 'adc' || brandData.tag === 'newstf'
										? 'green'
										: 'primary'
								} w-100 mb-12 ${brandData.tag}`}
								onClick={() => {
									handleUnlimited(ULitemCodeAU);
								}}
							>
								<span>{ctaCopy ? ctaCopy : 'Join now'}</span>
							</button>
						) : (
							<>
								<button
									type='button'
									className={'btn btn-primary w-100 mb-12 ' + brandData.tag}
									onClick={() => {
										handleUnlimited(ULitemCodeNZNorth);
									}}
								>
									North Island <br />
									$24.99 - JOIN NOW
								</button>
								<button
									type='button'
									className={'btn btn-primary w-100 mb-12 ' + brandData.tag}
									onClick={() => {
										handleUnlimited(ULitemCodeNZSouth);
									}}
								>
									South Island <br />
									$49.99 - JOIN NOW
								</button>
							</>
						)}

						<div
							className={`unlimited-upgrade__no btn btn-secondary btn-block bg p-12 mb-20 font-weight-normal position-relative ${
								unlForProspects ? 'hide' : ''
							} ${brandData.tag}`}
							onClick={() => handleUnlimited(false)}
						>
							<span>
								{noThanksCTACopy
									? noThanksCTACopy
									: `No${!unlForProspects ? ' thanks' : ''}`}
							</span>
						</div>
					</div>

					<div className='dmlp__conti-upgrade__tc mb-20'>
						{tc?.content && tc?.content.length > 0 ? (
							<>
								<span
									className={`text-decoration-underline cursor-pointer unlimited_terms_modal_link ${promoCode}`}
									onClick={() => setShowModal(true)}
								>
									Terms and Conditions
								</span>
								<Modal
									showModal={showModal}
									modalSize='600px'
									modalClass={`unlimited_terms_modal ${promoCode}`}
									toggleModal={() => setShowModal(!showModal)}
								>
									<RichTextRenderer content={tc} />
								</Modal>
							</>
						) : !unlForProspects ? (
							<>
								* This introductory offer is valid until 11th March 2021 and
								only available once per household. Your introductory membership
								is valid for 12 months from time of purchase. Unlimited members
								pay $10 for a 12 month membership. The regular annual membership
								fee is currently $39.99, to receive unlimited shipping on all
								wine orders of 12 or more bottles or orders valued above $148,
								that are placed during your active membership period. Your
								membership begins on the day you register and continues for 12
								months. After 12 months, we will email you a renewal notice (if
								no email address is provided, a renewal notice will not be
								issued), and unless you request otherwise, your Unlimited
								membership will automatically renew for another year (12 months)
								and your nominated payment method will be charged the annual
								membership fee, which is currently $39.99. Unlimited membership
								is not available in country areas, and we cannot accept orders
								or deliver to the Northern Territory. An additional postage
								surcharge will apply to any case/order shipped to an area where
								Unlimited membership is not available. Postcodes 6215–6699 will
								incur an additional charge of $5. Postcodes 6700–6797,
								6798-6799, 2899 and 7151 will incur an additional charge of $15.
								You may cancel your Unlimited membership at anytime and receive
								a full refund, provided you have not yet used the service. You
								can send to an unlimited amount of addresses within the eligible
								Unlimited regions for each Unlimited membership (all recipients
								must be 18 years or over). If you purchase wine while an active
								member, but the associated shipping charges are included in a
								second instalment that is due after your membership has ended,
								shipping charges will apply. We reserve the right to make
								changes to these terms, or any aspect of the Unlimited program,
								by posting revisions on our website. Your continued membership
								after such changes constitutes acceptance of the changes. If you
								do not agree to such changes, you must cancel your membership.
								We may terminate your Unlimited membership at our sole
								discretion without notice (in such cases, you will receive a
								prorated refund). By purchasing the Unlimited membership, you
								accept these terms and conditions. Void where prohibited by law.
							</>
						) : null}
					</div>
				</div>
			</div>
		</StyledUnlimitedWrapper>
	);
};

export default UnlimitedUpgrade;
